export enum PermissionType {
  CatalogManage = 1,
  CatalogDisable = 2,
  //CatalogPrices = 4,
  OrdersManage = 8,
  OrdersCancel = 8192,
  OrdersDiscounts = 131072,
  OrdersHistoric = 16,
  StoreSettings = 32,
  BranchSettings = 64,
  TablesManage = 128,
  TablesDisable = 256,
  QrGenerate = 512,
  UsersManage = 1024,
  TranslationsManage = 2048,
  StatisticsView = 4096,
  CajaManage = 16384,
  CustomersView = 32768,
  CustomersManage = 65536,
  ClubManage = 262144,
  ClubTopup = 524288,
  ReservationsManage = 1048576,
  ReservationsSettings = 2097152,
}
